<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="addRoleDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Role</div
  >

  <form class="flex w-80 flex-col" [formGroup]="addRoleForm" (ngSubmit)="add()">
    <ng-select
      #addRoleDialogRoleSelect
      [fixNgSelectBottom]="addRoleDialogRoleSelect"
      data-cy="addRoleDialogRoleInput"
      class="mt-9 w-80 text-base"
      [items]="availableRoles"
      bindLabel="roleId"
      bindValue="roleId"
      [clearable]="false"
      [searchable]="true"
      (keyup.esc)="
        $event.stopImmediatePropagation(); addRoleDialogRoleSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); addRoleDialogRoleSelect.blur()
      "
      appendTo="body"
      formControlName="role"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.roleId }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.roleId }}</div>
      </ng-template>
    </ng-select>
    <m-validation [control]="addRoleForm.controls['role']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="addRoleDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        [disabled]="availableRoles.length === 0"
        [ngClass]="{
          'bg-s400 cursor-default': availableRoles.length === 0
        }"
        >Add</button
      >

      <button
        data-cy="addRoleDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
